import  React  from "react";
import { Helmet } from 'react-helmet';
import '../../../src/assets/css/app.min.css';
import '../../../src/assets/css/app.min.css';
import '../../../src/assets/css/fontawesome.min.css';
import 'react-awesome-slider/dist/styles.css';
import '../../assets/css/responsive.css'
import '../../../src/assets/css/Slick_Cdn/bootstrap.min.css';
import Swal from "sweetalert2";
import axios from 'axios';
import Footer from "../../Footer";
import Header from "../../Header";
import 'react-circular-progressbar/dist/styles.css';
import { Modal } from 'react-bootstrap';
import './unity.css';

class Unitypage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Job: [],
            Description: '',
            name: '',
            email: '',
            number: '',
            subject: '',
            message: '',
            toDate: '',
            formErrors: {},
            setContactFormBool: false,
            show: false,
            isOpen: false,
            isActive: false,
            selectedDate: null,
            isAnimationRunning: true,
            autoplay: true        
        }

        this.onSubmit = this.onSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.endDateChange = this.endDateChange.bind(this);
        this.onClickShowdetails = this.onClickShowdetails.bind(this);
        this.maxlengthnumber = this.maxlengthnumber.bind(this);
      
    }
    componentDidMount() {

        axios.get("/careers")
            .then(response => {
                console.log("Data is::::::::", response.data);
                this.setState({ Job: Array.isArray(response.data) ? response.data : [] });
                this.setState({ Description: response.data[0].description });

            })
            .catch(function (error) {
                console.log(error);
            })
    }
       
    openModal(e) {
        this.setState({ isOpen: !this.state.isOpen });
    }
    handleOpenContectModal(e) {
        this.setState({ show: !this.state.show });
        console.log("state is::::::::", this.state.show);
    }
    handlevideopopup(e) {
        console.log("::::::add on this:");
        this.setState({ isActive: !this.state.isActive });
    }
    onContactFormHide(e) {
        console.log(" event ::::onContactFormHide:: ", this.state.setContactFormBool);
        this.setState({ setContactFormBool: false });
    }
    onContactFormShow(e) {
        console.log(" event ::onContactFormShow:::: ", this.state.setContactFormBool);
    
        this.setState({ show: !this.state.show })
    }
    onClickShowdetails(job) {
        console.log("job is:::::::", job);
        localStorage.setItem("Job", JSON.stringify(job));
        window.location.href = '/careerdetail';
    }
    handleChange(e) {
        this.setState({ ...this.state, [e.target.name]: e.target.value })
    }
    endDateChange(e) {
        this.setState({ toDate: e.target.value })
    }
    handleChangedatepicker = (date) => {
        this.setState({
            selectedDate: date,
        });
    };
    onClickblogdetails(blog) {
        console.log("blog is:::::::", blog);
        localStorage.setItem("Blog", JSON.stringify(blog));
        window.location.href = '/blogdetails';
    }
    closeModal() {
        this.setState({ show: !this.state.show });
    };
    handleClickInsideModal = (event) => {
        event.stopPropagation();
    }
    maxlengthnumber(evt) {
        if (evt.target.value.length === 11) {
            return false;
        }
        else {
            this.setState({ ...this.state, [evt.target.name]: evt.target.value })
        }
    }
    onSubmit(e) {
        e.preventDefault();
        let formErrors = {};
        console.log("Enter in::::::::::::");
        if (this.state.name === '' || this.state.name === null) {

            formErrors["nameError"] = "Name is required.";
            this.refs.namefield.focus();
            this.setState({ formErrors: formErrors, classForValid: 'form-control is-invalid' });
            return false;
        }
        else if (this.state.email === '' || this.state.email === null) {
            formErrors["emailError"] = "Email id is required.";
            this.refs.emailfield.focus();
            this.setState({ formErrors: formErrors, classForValid: 'form-control is-invalid' });

            return false;
        }
        else if (this.state.subject === '' || this.state.subject === null) {
            formErrors["subjectError"] = "Subect is required.";
            this.refs.subjectfield.focus();
            this.setState({ formErrors: formErrors, classForValid: 'form-control is-invalid' });

            return false;
        }
        else if (this.state.number === '' || this.state.number === null) {
            formErrors["numberError"] = "Number is required.";
            this.refs.numberfield.focus();
            this.setState({ formErrors: formErrors, classForValid: 'form-control is-invalid' });

            return false;
        }
        else if (this.state.message === '' || this.state.message === null) {
            formErrors["messageError"] = "Message is required.";
            this.refs.messagefield.focus();
            this.setState({ formErrors: formErrors, classForValid: 'form-control is-invalid' });

            return false;
        }  else {

            const formObject = {
                name: this.state.name,
                email: this.state.email,
                number: this.state.number,
                subject: 'Unity' + '-' + this.state.subject,
                toDate: this.state.toDate,
                message: this.state.message,

            };
            console.log("formObject::::::::::;", formObject);
            axios.post("/contactus", formObject)
                .then((res) => {
                    console.log("Response is:::::::::", res);
                    if (res.data !== 'undefined') {
                        Swal.fire({
                            title: "Thank you!",
                            text: "Your request has been assigned successfully.",
                            icon: "success",
                        }).then(function () {
                            window.location.reload();
                        });
                    } else {
                        Swal.fire({
                            title: "Oops...!",
                            text: "Oh! Something went wrong, please try again!",
                            icon: "error",
                        }).then(function () {
                            window.location.reload();
                        });
                    }

                });
        }


        this.setState({
            name: '',
            email: '',
            subject: '',
            number: '',
            message: ''

        })

    }
    render() {

        const mystylefour = {
            backgroundImage:
                "url('../assets/img/bg/cta_bg_1.png')",
            background: 'rgb(8, 14, 28)'
        };

        const unityDevelopmentServices = [
            {
                title: "Full-Cycle Unity Game Development",
                image: "assets/img/GameDevelopment/multiplayer_game.jpg",
                description: "From concept and prototyping to production, launch, and live support, we build Unity games with scalable architecture, engaging gameplay, polished visuals, and production-ready features.",
                points: ["Game concept and planning", "2D/3D gameplay development", "Launch-ready builds"]
            },
            {
                title: "Unity Multiplayer Game Development",
                image: "assets/img/GameDevelopment/vr.jpg",
                description: "We build real-time multiplayer systems, matchmaking, secure game logic, wallet/payment flows, analytics, admin tools, and live operations support for competitive Unity games.",
                points: ["Multiplayer backend integration", "Matchmaking and game rooms", "Analytics and live ops"]
            },
            {
                image: "assets/img/GameDevelopment/ar.jpg",
                title: "Unity AR/VR/MR Development",
                description: "We create immersive Unity experiences for AR, VR, and mixed reality with optimized interaction, spatial UI, device-ready performance, and strong visual presentation.",
                points: ["AR/VR interaction design", "Device optimization", "Immersive environments"]
            },
            {
                title: "Unity 2D & 3D Game Development",
                image: "assets/img/GameDevelopment/3d.jpg",
                description: "Our team develops responsive 2D and 3D games with smooth controls, refined mechanics, optimized assets, animation, UI, and gameplay systems built for player retention.",
                points: ["Casual, arcade, card, and board games", "3D assets and animation", "Performance-focused builds"]
            },
            {
                title: "Unity Mobile Game Development",
                image: "assets/img/GameDevelopment/onlinr-casino.jpg",
                description: "We develop Unity games for Android and iOS with responsive controls, optimized performance, monetization, analytics, store-ready builds, and device-focused QA.",
                points: ["Android and iOS builds", "Ads and analytics integration", "Store-ready releases"]
            },
            {
                title: "Unity Game Optimization & Live Support",
                image: "assets/img/GameDevelopment/2d.jpg",
                description: "We improve Unity game performance, loading speed, memory usage, asset quality, device compatibility, bug stability, content updates, and post-launch operations.",
                points: ["Performance optimization", "Bug fixing and QA", "Updates and live support"]
            }
        ];

        const unityWhyChoose = [
            {
                icon: "fa-solid fa-gamepad",
                title: "Gameplay Engineering",
                description: "We build polished gameplay systems, controls, progression, camera behavior, UI flows, and interactive mechanics for Unity games."
            },
            {
                icon: "fa-solid fa-mobile-screen-button",
                title: "Cross-Platform Builds",
                description: "Our Unity team prepares Android, iOS, WebGL, PC, and console-ready builds with platform-specific UI, controls, and performance checks."
            },
            {
                icon: "fa-solid fa-server",
                title: "Multiplayer Backend",
                description: "We connect Unity games with APIs, databases, matchmaking, game rooms, leaderboards, wallet systems, analytics, and admin panels."
            },
            {
                icon: "fa-solid fa-cubes",
                title: "Art, UI & Animation Support",
                description: "2D/3D artists, animators, UI designers, and technical artists support Unity production with optimized assets and visual polish."
            },
            {
                icon: "fa-solid fa-clipboard-check",
                title: "QA & Performance Testing",
                description: "We test gameplay, devices, performance, memory, loading, monetization, edge cases, store readiness, and release stability."
            },
            {
                icon: "fa-solid fa-headset",
                title: "Store Publishing & LiveOps",
                description: "After launch, we support updates, bug fixes, analytics, monetization, ad integration, store publishing, and live game operations."
            }
        ];

        const unityProcess = [
            { step: "01", title: "Discovery", description: "We define game goals, genre, target users, platforms, core gameplay, monetization, and technical scope." },
            { step: "02", title: "Prototype", description: "We validate controls, gameplay loops, mechanics, art direction, and technical feasibility before full production." },
            { step: "03", title: "Art & UI", description: "Our team prepares UI screens, 2D/3D assets, animation, environments, VFX, and production-ready visual assets." },
            { step: "04", title: "Development", description: "We build gameplay systems, multiplayer logic, backend integrations, analytics, ads, payments, and platform builds." },
            { step: "05", title: "QA & Optimization", description: "We test bugs, performance, devices, memory, loading, gameplay balance, store rules, and release readiness." },
            { step: "06", title: "Launch & Support", description: "We help with publishing, updates, monitoring, live operations, new content, fixes, and product improvements." }
        ];

        const unityPlatforms = [
            "Android",
            "iOS",
            "WebGL",
            "PC",
            "Console",
            "AR/VR",
            "Multiplayer",
            "Node.js Backend",
            "Firebase",
            "Ads & Analytics",
            "Store Publishing",
            "LiveOps"
        ];
        
        var Information;
        if (Array.isArray(this.state.Job) && this.state.Job.length) {
            Information = this.state.Job.map((job) =>
                <>
                    <li>
                        <a href="#" onClick={() => this.onClickShowdetails(job)}>{job.job}</a>
                    </li>
                </>
            )
        } else {
            Information = <div><h4 style={{ color: "Red", fontSize: "20px" }}>No Record Found !</h4></div>;
        }
        const { nameError, emailError, subjectError, numberError, messageError } = this.state.formErrors;
        return (
            <>
                <Helmet>

                    <title>Unity Game Development Company | Oengines Games LLP</title>
                    <meta name="description" content="Oengines Games LLP provides Unity game development services for 2D, 3D, multiplayer, mobile, WebGL, PC, AR/VR, optimization, QA, launch, and live support." />
                    <meta name="keywords" content="Unity game development company, Unity game development services, Unity 2D game development, Unity 3D game development, Unity mobile game development, Unity multiplayer game development, Unity AR VR development" />
                    <link href="https://cdn.jsdelivr.net/npm/@coreui/coreui@4.2.0/dist/css/coreui.min.css" rel="stylesheet" integrity="sha384-UkVD+zxJKGsZP3s/JuRzapi4dQrDDuEf/kHphzg8P3v8wuQ6m9RLjTkPGeFcglQU" crossorigin="anonymous" />
                    <link href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.css" />
                    <script src="https://cdn.jsdelivr.net/npm/@coreui/coreui@4.2.0/dist/js/coreui.bundle.min.js" integrity="sha384-n0qOYeB4ohUPebL1M9qb/hfYkTp4lvnZM6U6phkRofqsMzK29IdkBJPegsyfj/r4" crossorigin="anonymous"></script>                
                    <script src="https://cdn.rawgit.com/progers/pathseg/master/pathseg.js" type="text/javascript"></script>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js"></script>
                    <script src="../assets/js/mian.js" type="Javascript"></script>
                    <script src="../assets/js/script.js" type="text/Javascript"></script>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js"></script>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery-circle-progress/1.1.3/circle-progress.min.js"></script>
                </Helmet>
                {/* <div className="loader" ><span>Loading...</span></div> */}
                <Header />
                <Modal size="lg" show={this.state.isActive} onClick={this.handleClickInsideModal} className="modal_contect video-effect-modal modalvideos" centered>
                    <Modal.Header closeButton className="modal_header p-0 border-none" style={{border: "none"}} onHide={() => this.handlevideopopup()} >                                            
                    </Modal.Header>
                    <Modal.Body>
                        <iframe width="960" height="415" src="https://www.youtube.com/embed/9xwazD5SyVg?autoplay=1&mute=1" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.isOpen} onClick={this.handleClickInsideModal} className="modal_contect video-effect-modal" centered>
                    <Modal.Header closeButton onHide={() => this.openModal()} >
                        <h5 className="modal-title m-auto" id="exampleModalLabel">Contact Us</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={this.onSubmit} method="post" className="contact-form ajax-contact">
                            <div className="row">
                                <div className="form-group col-md-6 col-sm-6">
                                    <input type="text" ref="namefield" className={nameError ? "form-control is-invalid" : "form-control"} name="name" id="name" placeholder="Your Name" onChange={this.handleChange} autoComplete="Off" />
                                    <i className="fal fa-user"></i>
                                    {nameError &&
                                        <div className="invalid-feedback" >{nameError}</div>
                                    }
                                </div>
                                <div className="form-group col-md-6 col-sm-6">
                                    <input type="email" className={emailError ? "form-control is-invalid" : "form-control"} ref="emailfield" name="email" id="email" placeholder="Email Address" onChange={this.handleChange} autoComplete="Off" />
                                    <i className="fal fa-envelope"></i>
                                    {emailError &&
                                        <div className="invalid-feedback">{emailError}</div>
                                    }
                                </div>
                                <div className="form-group col-md-6 col-sm-6">
                                    <select name="subject" id="subject" ref="subjectfield" className={subjectError ? "form-control is-invalid" : "form-control"} onChange={this.handleChange} autoComplete="Off">
                                        <option disabled="disabled">Select Subject
                                        </option>
                                        <option defaultValue={"Full-Cycle Unity Game Development"}>Full-Cycle Unity Game Development</option>
                                        <option defaultValue={"Unity AR/VR Game Development"}>Unity AR/VR Game Development</option>
                                        <option defaultValue={"Unity 2D/3D Game Development"}>Unity 2D/3D Game Development</option>
                                        <option defaultValue={"Unity Multiplayer Game Development"}>Unity Multiplayer Game Development</option>
                                        <option defaultValue={"Unity Mobile Game Development"}>Unity Mobile Game Development</option>
                                        <option defaultValue={"Unity Game Optimization"}>Unity Game Optimization</option>
                                    </select>
                                    {subjectError &&
                                        <div className="invalid-feedback">{subjectError}</div>
                                    }
                                </div>
                                <div className="form-group col-md-6 col-sm-6">
                                    <input type="number" className={numberError ? "form-control is-invalid" : "form-control"} name="number" ref="numberfield" id="number" placeholder="Phone Number" autoComplete="Off" maxLength={10} onChange={this.maxlengthnumber} value={this.state.number} />
                                    <i className="fal fa-phone"></i>
                                    {numberError &&
                                        <div className="invalid-feedback">{numberError}</div>
                                    }
                                </div>

                                <div className="form-group col-12">
                                    <textarea name="message" id="message" cols="30" rows="3" ref="messagefield"
                                        className={messageError ? "form-control is-invalid" : "form-control"} placeholder="Your Message" onChange={this.handleChange} autoComplete="Off">
                                    </textarea>
                                    <i className="fal fa-comment"></i>
                                    {messageError &&
                                        <div className="invalid-feedback">{messageError}</div>
                                    }
                                </div>
                                <div className="form-btn text-xl-start text-center col-12">
                                    <button type="submit" className="as-btn style3 send-qty">Send Details
                                        <i className="fa-regular fa-arrow-right ms-2"></i>
                                    </button>
                                </div>
                            </div>
                            <p className="form-messages mb-0 mt-3"></p>
                        </form>
                    </Modal.Body>
                </Modal>
                <div className="slider-area">
                    <div className="container-fluid padding-contorler-am-slide">
                        <div className="row d-flex align-items-center">
                            <div className="col-lg-6 col-xl-6 order-2 order-xl-1 padding-contorler-am-slide-right">

                                <div className="banner-top-rating sal-animate">
                                    <div className="banner-badge-top" data-sal-delay="300" data-sal="slide-up" data-sal-duration="500">
                                        <div className="icons">
                                            <img src="../assets/img/icon/rating-2.png" alt="Icons Images"/>
                                        </div>
                                        <span className="subtitle">Unity Game Team</span>
                                    </div>

                                    <div className="banner-badge-top" data-sal-delay="500" data-sal="slide-up" data-sal-duration="500">
                                        <div className="icons">
                                            <img src="../assets/img/icon/trophy.png" alt="Icons Images"/>
                                        </div>
                                        <span className="subtitle">Launch-Ready Builds</span>
                                    </div>
                                </div>

                                <h1 className="title large-height theme-color unity-hero-title" data-sal-delay="200" data-sal="slide-up" data-sal-duration="800">Unity Game Development Company</h1>
                                <p className="slide-disc mt-20 unity-hero-text" data-sal-delay="300" data-sal="slide-up" data-sal-duration="800">Build scalable 2D, 3D, multiplayer, AR/VR, mobile, web, and PC games with Oengines Games LLP. Our Unity developers, artists, designers, QA testers, and backend engineers help you move from concept to launch-ready product.</p>
                                <div className="button-group">
                                    <a className="as-btn style1 btn-6 mb-30" onClick={(e) => this.openModal(e)} style={{border: "none"}} data-sal-delay="400" data-sal="slide-up" data-sal-duration="800">Start Your Unity Project</a>                                   
                                </div>
                            </div>
                            <div className="col-lg-6 col-xl-6 order-1 order-xl-2">

                                <div className="banner-gallery-wrapper">
                                    <div className="banner-gallery-loop">
                                        <div className="banner-gallery banner-gallery-1 mt--90">
                                            <img src="../assets/img/banner/banner-01.png" alt="Banner Images"/>
                                            <img src="../assets/img/banner/banner-01.png" alt="Banner Images"/>
                                        </div>
                                        <div className="banner-gallery banner-gallery-2">
                                            <img src="../assets/img/banner/banner-02.png" alt="Banner Images"/>
                                            <img src="../assets/img/banner/banner-02.png" alt="Banner Images"/>
                                        </div>
                                        <div className="banner-gallery banner-gallery-3 mt--90">
                                            <img src="../assets/img/banner/banner-03.png" alt="Banner Images"/>
                                            <img src="../assets/img/banner/banner-03.png" alt="Banner Images"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
              
                <section className="unity-why-choose-area unity-development-services pt-100 pb-70">
                    <div className="container">
                        <div className="section-title-two">
                            <div className="row align-items-center">
                                <div className="col-lg-7">
                                    <div className="title text-white">
                                            <span>Unity Development Services</span>
                                            <h2>Our Unity Game Development Services</h2>
                                    </div>
                                </div>
                                <div className="col-lg-5">
                                        <div className="text">
                                            <p className="text-white">Build production-ready Unity games and immersive experiences for mobile, web, PC, AR/VR, multiplayer, and real-money game platforms.</p>
                                        </div>
                                </div>
                            </div>
                        </div>

                        <div className="row g-4 unity-development-grid">
                            {unityDevelopmentServices.map((service, index) => (
                                <div className="col-lg-4 col-md-6" key={service.title}>
                                    <div className="unity-development-card">
                                        <div className="unity-development-media">
                                            <img src={service.image} alt={service.title} />
                                            <span>{String(index + 1).padStart(2, '0')}</span>
                                        </div>
                                        <div className="unity-development-content">
                                            <h3>{service.title}</h3>
                                            <p>{service.description}</p>
                                            <ul>
                                                {service.points.map((point) => (
                                                    <li key={point}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
                <section className="unity-why-oengines space">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xl-8 col-lg-10">
                                <div className="unity-section-heading text-center">
                                    <span>Why Choose Oengines for Unity</span>
                                    <h2>Unity Game Development Backed by Design, Art, Backend, QA & Live Support</h2>
                                    <p>We bring the technical and creative teams needed to build, optimize, publish, and support Unity games across platforms.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row g-4">
                            {unityWhyChoose.map((item) => (
                                <div className="col-md-6 col-xl-4" key={item.title}>
                                    <div className="unity-why-card">
                                        <span><i className={item.icon}></i></span>
                                        <h3>{item.title}</h3>
                                        <p>{item.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="unity-process-section space">
                    <div className="container">
                        <div className="row align-items-end justify-content-between">
                            <div className="col-xl-6 col-lg-7">
                                <div className="unity-section-heading">
                                    <span>Unity Development Process</span>
                                    <h2>From Game Idea to Launch-Ready Unity Build</h2>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-5">
                                <p className="unity-process-intro">Our workflow keeps gameplay, UI, art, engineering, backend, testing, and deployment aligned from the first prototype to long-term support.</p>
                            </div>
                        </div>
                        <div className="unity-process-grid">
                            {unityProcess.map((item) => (
                                <div className="unity-process-card" key={item.step}>
                                    <span>{item.step}</span>
                                    <h3>{item.title}</h3>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="unity-platform-section space">
                    <div className="container">
                        <div className="unity-platform-panel">
                            <div className="row align-items-center g-4">
                                <div className="col-lg-5">
                                    <div className="unity-section-heading mb-0">
                                        <span>Platforms & Integrations</span>
                                        <h2>Unity Technology Coverage for Complete Game Delivery</h2>
                                        <p>We support the Unity ecosystem around platform builds, backend systems, monetization, analytics, publishing, and ongoing game operations.</p>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="unity-platform-list">
                                        {unityPlatforms.map((platform) => (
                                            <span key={platform}>{platform}</span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="unity-cta-strip">
                    <div className="container">
                        <div className="unity-cta-strip__inner">
                            <div>
                                <span>Many successful games are built with Unity</span>
                                <h2>Need a Unity team for your next game?</h2>
                            </div>
                            <button className="as-btn" onClick={(e) => this.openModal(e)} style={{border: "none"}}>Book Consultation
                                <i className="fa-regular fa-arrow-right ms-2"></i>
                            </button>
                        </div>
                    </div>
                </section>
                {/* <section className="component component-callout component-callout__image-background ptb--60">
                    <div className="container">
                        <div id="create-and-grow-more-unity--2" className="uni-bg component-callout component-callout__inner has-overlay has-overlay--darken-30">
                            <div className="row has-overlay__inner">
                                <div className="col-xs-12 col-sm-offset-1 col-sm-8">
                                    <h2 className="component-callout__title color-white">
                                        <div>Create and grow more with Unity</div>
                                    </h2>
                                    <div className="component-callout__description large">
                                        <div><p>Unity is the leading video game engine – and so much more. Discover solutions to help us at every stage of the game development lifecycle, from big idea to big success.</p>
                                        </div>
                                    </div>
                                    <div className="component-callout__buttons md-m-top">
                                        <a href="#" className="as-btn style1 btn-6">Learn more</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}

                <Footer />
            </>
        )
    }
}

export default Unitypage;

